<template>
    <div class="mb-3 col-12 col-lg-6 card">
        <div class="card-body">
            <input type="text" class="form-control fs-3" v-model="name" >
            <div class="mt-2 d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-secondary me-2" @click="cancel"><i class="fas fa-ban me-2"></i>Cancel</button>
                <button type="button" class="btn btn-sm btn-primary" @click="update" :disabled="!valid"><i class="far fa-save me-2"></i>Save</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
        }
    },

    computed: {
        valid: function() {
            if (this.name.length > 4) {
                return true
            }
            return false;
        }
    },

    methods: {
        update: function() {
            this.$emit('input', this.name);
        },

        cancel: function() {
            this.$emit('cancel');
        }
    },

    data() {
        return {
            name: this.value,
        };
    }
}

</script>